import React from 'react'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import ModalDadosComprador from './ModalDadosComprador';
import { paisesDDI } from '../../util/constantsUtil';

export const validate = (values) => {
  const errors = {};
  if (!values.nome) {
    errors.nome = 'Campo obrigatório'
  }
  if (!values.email) {
    errors.email = 'Campo obrigatório'
  }
  if (!values.cpf) {
    errors.cpf = 'Campo obrigatório'
  }
  if (!values.telefone) {
    errors.telefone = 'Campo obrigatório'
  }

  return errors
};

export class DadosComprador extends React.Component {
  constructor (props) {
    super(props);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.state = {
      mensagem: { tipo: '', texto: '' },
      arquivo: null
    };
  }


  alterarAba (aba) {
    this.setState({ tabAtiva: aba })
  }

  ativarAba (aba) {
    if (aba === this.state.tabAtiva) {
      return 'nav-link active'
    }
    return 'nav-link'
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formReserva');
    this.limparMensagem();
  }

  getDDi(ddiComprador) {
    return paisesDDI.find(it => it.id === ddiComprador)
  }

  formatarDDi(comprador) {
    const ddiComprador = this.getDDi(comprador)
    return `${ddiComprador.pais} ${ddiComprador.ddi}`
  }

  preencherValoresComprador (comprador) {
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'nome', comprador.nomeComprador);
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'cpf', comprador.cpfComprador);
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'telefone', comprador.telefoneComprador);    
    if (comprador.ddiComprador) {      
      const ddiComprador = this.getDDi(comprador.ddiComprador)
      this.props.changeFieldValue('formularioCadastrarDadosComprador', 'ddiComprador', { label: `${ddiComprador.pais} ${ddiComprador.ddi}`,  value: ddiComprador.id });
    } else {
      this.props.changeFieldValue('formularioCadastrarDadosComprador', 'ddiComprador', {label: 'Brasil +55', value: 32});
    }
  }

  render () {
    if (this.props.dadosPagamento) {
      return (
        <React.Fragment>
          <div className="vx-buyer-card">
            <div className="vx-buyer-header">
              <div className="vx-buyer-header-left">
                <i className="material-icons">account_circle</i>
                <span className="vx-buyer-title">Dados de pagamento</span>
              </div>
              <button type="button" className="vx-buyer-edit-btn"
                      data-toggle="modal" data-target="#modalCadastrarDadosComprador"
                      onClick={() => this.preencherValoresComprador(this.props.dadosPagamento)}>
                <i className="material-icons">edit</i>
                Editar
              </button>
            </div>
            <div className="vx-buyer-grid">
              <div className="vx-buyer-field">
                <span className="vx-buyer-field-label">Nome</span>
                <span className="vx-buyer-field-value">{this.props.dadosPagamento.nomeComprador}</span>
              </div>
              <div className="vx-buyer-field">
                <span className="vx-buyer-field-label">CPF</span>
                <span className="vx-buyer-field-value">{this.props.dadosPagamento.cpfComprador}</span>
              </div>
              <div className="vx-buyer-field">
                <span className="vx-buyer-field-label">DDI</span>
                <span className="vx-buyer-field-value">{this.formatarDDi(this.props.dadosPagamento.ddiComprador)}</span>
              </div>
              <div className="vx-buyer-field">
                <span className="vx-buyer-field-label">Telefone</span>
                <span className="vx-buyer-field-value">{this.props.dadosPagamento.telefoneComprador}</span>
              </div>
            </div>
          </div>
          <ModalDadosComprador empresaSelecionada={this.props.empresaSelecionada}/>
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        <div className="vx-buyer-empty">
          <i className="material-icons vx-buyer-empty-icon">person_add</i>
          <p className="vx-buyer-empty-text">Nenhum comprador informado</p>
          <button type="button" className="vx-buyer-add-btn"
                  data-toggle="modal" data-target="#modalCadastrarDadosComprador">
            <i className="material-icons">add</i>
            Adicionar dados do comprador
          </button>
        </div>
        <ModalDadosComprador empresaSelecionada={this.props.empresaSelecionada}/>
      </React.Fragment>
    )
  }
}

export function mapStateToProps (state) {
  return {
    dadosPagamento: state.dadosPagamento,
    empresaSelecionada: state.empresaSelecionada
  }
}

export default connect(mapStateToProps, {
  adicionarDadosComprador, changeFieldValue
})(reduxForm({
  form: 'formReserva',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(DadosComprador));
